module.exports = __webpack_public_path__ + "static/gallery_wild_3-242280802b7f16e5288319d1a5aae324.jpg";